export default __webpack_public_path__ + "static/avatar-6efd7dc7abf5e40e639ea555f68d6a78.webp";